<template>
  <div>
    <vs-table v-if="isRadar" stripe search :data="devices" class="table">
      <template slot="header">
        <h3>Radars</h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="alias">Name</vs-th>
        <vs-th>Position</vs-th>
        <vs-th>Distance</vs-th>
        <vs-th sort-key="variableAlias">Variable</vs-th>
        <vs-th>Units</vs-th>
        <vs-th>Type</vs-th>
        <vs-th>Source</vs-th>
        <vs-th sort-key="timeResolution">Time Resolution (h)</vs-th>
        <vs-th sort-key="spatialResLonKm">(Lon) Spatial Res.</vs-th>
        <vs-th sort-key="spatialResLatKm">(Lat) Spatial Res.</vs-th>
        <vs-th>Catalog</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody ref="tbody">
          <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr">
            <vs-td :data="data[indextr].alias">{{ data[indextr].alias }}</vs-td>
            <vs-td :data="data[indextr]">
              {{
                data[indextr].longitude != null
                  ? `${data[indextr].longitude.toFixed(4)}°`
                  : "-"
              }}
              /
              {{
                data[indextr].latitude != null
                  ? `${data[indextr].latitude.toFixed(4)}°`
                  : "-"
              }}
            </vs-td>
            <vs-td :data="data[indextr].distance">
              {{
                data[indextr].distance > 0
                  ? `${data[indextr].distance.toFixed(0)} km`
                  : "-"
              }}
            </vs-td>
            <vs-td :data="data[indextr].variable">
              {{ data[indextr].variable.alias }}
            </vs-td>
            <vs-td :data="data[indextr].variable">
              {{ data[indextr].variable.units }}
            </vs-td>
            <vs-td :data="data[indextr].type">{{ data[indextr].type }}</vs-td>
            <vs-td
              :data="data[indextr].source"
              :title="data[indextr].source.longName"
              >{{ data[indextr].source.alias }}</vs-td
            >
            <vs-td :data="data[indextr].timeResolution">{{
              data[indextr].timeResolution
            }}</vs-td>
            <vs-td :data="data[indextr].spatialResLonKm">
              {{ data[indextr].spatialResLonKm }}km
            </vs-td>
            <vs-td :data="data[indextr].spatialResLatKm">
              {{ data[indextr].spatialResLatKm }}km
            </vs-td>
            <vs-td :data="data[indextr].catalog">
              <a
                :href="data[indextr].urlBase + '/' + data[indextr].catalog"
                target="blank"
              >
                <i title="Go to Data Catalog" class="material-icons viewer-ico"
                  >folder_open</i
                >
              </a>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-table v-else stripe search :data="devices" class="table">
      <template slot="header">
        <h3>Buoys</h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="nombre">Name</vs-th>
        <vs-th>Position</vs-th>
        <vs-th>Distance</vs-th>
        <vs-th>Data</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody ref="tbody">
          <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr">
            <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
            <vs-td :data="data[indextr]">
              {{
                data[indextr].longitude != null
                  ? `${data[indextr].longitude}°`
                  : "-"
              }}
              /
              {{
                data[indextr].latitude != null
                  ? `${data[indextr].latitude}°`
                  : "-"
              }}
            </vs-td>
            <vs-td :data="data[indextr].distance">
              {{
                data[indextr].distance > 0
                  ? `${data[indextr].distance} km`
                  : "-"
              }}
            </vs-td>
            <vs-td>
              <i
                title="Show last data"
                class="material-icons viewer-ico"
                @click="onViewData(data[indextr])"
                >timeline</i
              >
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>
export default {
  props: {
    devices: {
      type: Array,
      required: true
    },
    isRadar: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onViewData(item) {
      this.$emit("onViewData", item);
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  text-align: left;
}
.vs-table--tbody-table .tr-values.selected {
  cursor: default;
}
.viewer-ico {
  margin-left: 10px;
  color: $secondary-color;
  cursor: pointer;
}
.vs-chip--text.con-vs-avatar {
  background: $secondary-color !important;
}
</style>
